/**
 * 房态组件取数：前端直调 FSM aliasCountList + 本地缓存（房型列表永久，房型信息 1 分钟）
 * 先读 localStorage 展示，再按需后台刷新，有缓存时不显示 loading 动画
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useState, useCallback, useEffect } from 'react';
import { createTableColumns } from '../config';
import { createProgressCellRender } from '../../../utils/tableUtils';
import { removeParenthesesFromRoomTypeName } from '../../../utils/priceChannelDataTransformer';
import { getRoomStatusWithCache, getRoomStatusFromLocalStorageSync } from '../utils/roomStatusCache';
var emptyData = {
    dataSource: [],
    columns: createTableColumns([], createProgressCellRender),
};
function toHookData(roomStatus) {
    var dataSource = (roomStatus.dataSource || []).map(function (item) { return (__assign(__assign({}, item), { label: item.label ? removeParenthesesFromRoomTypeName(item.label) : item.label, priceData: item.priceData || [], normalizedReferenceLines: item.normalizedReferenceLines || [] })); });
    return { dataSource: dataSource, columns: createTableColumns(dataSource, createProgressCellRender) };
}
export function useRoomStatusData(storeId, options) {
    var enabled = (options === null || options === void 0 ? void 0 : options.enabled) !== false;
    var _a = useState(function () {
        if (!enabled)
            return emptyData;
        var fromLocal = getRoomStatusFromLocalStorageSync(storeId);
        return fromLocal ? toHookData(fromLocal) : emptyData;
    }), data = _a[0], setData = _a[1];
    var _b = useState(function () { return enabled && !getRoomStatusFromLocalStorageSync(storeId); }), loading = _b[0], setLoading = _b[1];
    var _c = useState(null), error = _c[0], setError = _c[1];
    var _d = useState(0), refreshKey = _d[0], setRefreshKey = _d[1];
    var refresh = useCallback(function () { return setRefreshKey(function (k) { return k + 1; }); }, []);
    useEffect(function () {
        if (!enabled) {
            setLoading(false);
            setError(null);
            setData(emptyData);
            return;
        }
        var cancelled = false;
        var hasInitialData = !!getRoomStatusFromLocalStorageSync(storeId);
        if (!hasInitialData)
            setLoading(true);
        setError(null);
        getRoomStatusWithCache(storeId, { dataSource: [] })
            .then(function (roomStatus) {
            if (cancelled)
                return;
            setData(toHookData(roomStatus));
            setError(null);
        })
            .catch(function (err) {
            if (!cancelled) {
                setError(err instanceof Error ? err : new Error(String(err)));
                setData(emptyData);
            }
        })
            .finally(function () {
            if (!cancelled)
                setLoading(false);
        });
        return function () { cancelled = true; };
    }, [storeId, refreshKey, enabled]);
    return { data: data, loading: loading, error: error, refresh: refresh };
}
